import adminServiceApi from "src/utils/AdminServiceApi";

export const ArtisansServices = {
  getAllArtisans: async () => {
    return adminServiceApi().get("artisan/v1/");
  },
  getAllStaleArtisans: async () => {
    return adminServiceApi().get("artisan/v1/dashboard/artisan/stale");
  },
  deleteStaleArtisans: async (payload: { artisanIds: string[] }) => {
    return adminServiceApi().delete(`artisan/v1/dashboard/artisan/stale`, {
      data: payload,
    });
  },
  getAllArtisansVerification: async (
    page: number,
    limit: number,
    search: string,
    filter: string,
  ) => {
    return adminServiceApi().get(
      `artisan/v1/verification?page=${page}&limit=${limit}&search=${search}&filter=${filter}`,
    );
  },
  getArtisan: async (artisan_id: string) => {
    return adminServiceApi().get(`artisan/v1/profile/${artisan_id}`);
  },
  getArtisanVerification: async (artisan_id: string) => {
    return adminServiceApi().get(`artisan/v1/verification/${artisan_id}`);
  },
  suspendArtisan: async (artisan_id: string, data: any) => {
    return adminServiceApi().post(`artisan/v1/${artisan_id}/suspend`, data);
  },
  unSuspendArtisan: async (artisan_id: string, data: any) => {
    return adminServiceApi().post(`artisan/v1/${artisan_id}/unsuspend`, data);
  },
  initiateWithdrawalAdmin: async (payload: {
    amount: number;
    narration: string;
    id: string;
  }) => {
    return adminServiceApi().post("artisan/v1/wallet/withdraw/admin", payload);
  },
  otpWithdrawalAdmin: async (payload: {
    code: number;
    id: string;
  }) => {
    return adminServiceApi().post("artisan/v1/wallet/withdraw/process/admin", payload);
  },
  updateArtisan: async (artisan_id: string, data: any) => {
    return adminServiceApi().put(`artisan/v1/profile/${artisan_id}`, data);
  },
  validateAccount: async (payload: {
    account_number: string;
    bank_code: string;
  }) => {
    return adminServiceApi().post(
      "artisan/v1/admin/wallet/verify-account",
      payload,
    );
  },
  updateWithdrawalBank: async (payload: {
    account_number: string;
    bank_code: string;
    bank_name: string;
    user_id?: string;
    artisan_id?: string;
  }) => {
    return adminServiceApi().post("artisan/v1/admin/wallet/bank", payload);
  },
  addWithdrawalBank: async (payload: {
    account_number: string;
    bank_code: string;
    bank_name: string;
    artisan_id?: string;
  }) => {
    return adminServiceApi().post("artisan/v1/wallet/bank/admin", payload);
  },
  withdrawalBank: async (payload: {
    amount: Number;
    description: string;
    narration: string;
    user_id: string;
  }) => {
    return adminServiceApi().post("artisan/v1//wallet/fund/artisan", payload);
  },
  DumpArtisansData: async () => {
    return adminServiceApi().get("artisan/v1/dashboard/dump-data");
  },
  chargeVerificationFee: async (artisan_id: string) => {
    return adminServiceApi().post(
      `artisan/v1/verification/${artisan_id}/charge-fee`,
    );
  },
  deleteProfilePic: async (artisan_id: string) => {
    return adminServiceApi().put(
      `artisan/v1/profile/remove_profile_picture/${artisan_id}`,
    );
  },
  bringVendorsOnline: async (status: string) => {
    return adminServiceApi().put(`artisan/v1/profile/all/availability`, {
      status,
    });
  },
  getArtisanFeedbacks: async (
    page: number = 1,
    emojiRating: string = "",
    limit: number = 10,
  ) => {
    return adminServiceApi().get(
      `artisan/v1/dashboard/artisan/feedback?page=${page}&emojiRating=${emojiRating}&limit=${limit}`,
    );
  },
  getArtisanPinnedFeedbacks: async (
    page: number = 1,
    emojiRating: string = "",
    limit: number = 10,
  ) => {
    return adminServiceApi().get(
      `artisan/v1/dashboard/artisan/pinned-feedback?page=${page}&emojiRating=${emojiRating}&limit=${limit}`,
    );
  },
  pinArtisanFeedback: async (id: string, pinned: boolean) => {
    return adminServiceApi().put(
      `artisan/v1/dashboard/artisan/pin-feedback/${id}`,
      { pinned },
    );
  },
  exportArtisanFeedback: async () => {
    return adminServiceApi().get("artisan/v1/dashboard/artisan");
  },
};
